import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { getOrderTotal } from '../../selectors/cart';
import Marketing from './Marketing';

class GenericPixel extends Marketing {
  pixelIframe = null;

  reportEvent = (type, args = {}) => {
    if (!this.pixelIframe) return;

    args.source = 'genericPixel';
    args.action = type;
    args.eventId = this.props.eventIds[0];
    args.listingSlug = this.props.listingSlug;

    this.pixelIframe.contentWindow.postMessage(args, '*');
  }

  constructor(props) {
    super(props);

    this.localStoragePrefix = 'GenericPixel_onReservationComplete_';
    this.reportAddPaymentInfo = false;
    this.pixelIframe = document.getElementById('generic-pixel');

    if (!this.pixelIframe) return;

    // subscribe to hooks
    this.props.addReservationCompleteHook(this.onReservationComplete);
    this.props.addStateTransitionHook(this.onStateTransition);
    this.props.addTicketsAddedToCartHook(this.onTicketsAdded);
    this.props.addProductsAddedToCartHook(this.onProductsAdded);
    this.props.addBundlesAddedToCartHook(this.onBundlesAdded);
    this.props.addTicketsRemovedFromCartHook(this.onTicketsRemoved);
    this.props.addProductsRemovedFromCartHook(this.onProductsRemoved);
    this.props.addBundlesRemovedFromCartHook(this.onBundlesRemoved);
  }
}

const mapStateToProps = state => {
  const eventIds = state.event.childEvent ? [state.event.childEvent.event_id] : Object.keys(state.event.events);
  return {
    payments: state.payment.payments,
    confirmationNumber: state.reservation.confirmation_number,
    currency: state.reservation.currency || 'USD',
    orderTotal: getOrderTotal(state)?.amount ?? 0,
    tickets: state.tickets.tickets,
    productSales: state.productSales.products,
    bundleSales: state.bundleSales.bundles,
    eventIds: eventIds,
    listingSlug: state.ui.listingSlug,
  }
}

const mapDispatchToProps = dispatch => {
  const actions = {};
  Object.keys(hookActions).forEach(hookActionName => {
    actions[hookActionName] = hookActions[hookActionName];
  });
  return bindActionCreators(actions, dispatch);
}

GenericPixel.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(GenericPixel)
